import VueRouter from 'vue-router';
import store from '../store/index.js';
import Swal from "sweetalert2";

import SelectModel from '../pages/SelectModel.vue';
import SelectGearbox from '../pages/SelectGearbox.vue';
import SelectFuel from '../pages/SelectFuel.vue';
import SelectTrim from '../pages/SelectTrim.vue';
import SelectEngine from '../pages/SelectEngine.vue';
import SelectPaint from '../pages/SelectPaint.vue';
import SelectInterior from '../pages/SelectInterior.vue';
import PersonaliseFinance from '../pages/PersonaliseFinance.vue';
import {getBestMatchingRouteBasedOnCurrentState, routeRequirementsMet} from './modules/routeRequirements.js';

let routes = [
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/configurator',
        name: 'select-model',
        props: true,
        component: SelectModel
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/configurator/:urlModel/select-gearbox',
        name: 'select-gearbox',
        props: true,
        component: SelectGearbox
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/configurator/:urlModel/select-fuel',
        name: 'select-fuel',
        props: true,
        component: SelectFuel
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/configurator/:urlModel/select-trim',
        name: 'select-trim',
        props: true,
        component: SelectTrim
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/configurator/:urlModel/select-engine',
        name: 'select-engine',
        props: true,
        component: SelectEngine
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/configurator/:urlModel/select-paint',
        name: 'select-paint',
        props: true,
        component: SelectPaint
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/configurator/:urlModel/select-interior',
        name: 'select-interior',
        props: true,
        component: SelectInterior
    },
    {
        path: '/:brand(peugeot|citroen|ds|vauxhall|fiat|abarth|alfa-romeo|jeep|leapmotor)/configurator/:urlModel/personalise-finance',
        name: 'personalise-finance',
        props: true,
        component: PersonaliseFinance
    }
];

const router = new VueRouter({
    mode: 'history',
    routes,
    base: '/',
    linkActiveClass: 'active',
    scrollBehavior: (to, from, savedPosition) => {
        return {x: 0, y: 0};
    }
});

router.beforeEach(async (to, from, next) => {
    if (!to.params.urlModel) {
        window.scrollTo(0, 0);

        next();
        return;
    }

    try {
        // Make sure we have the model from the URL
        await store.dispatch('getNewModel', {
            brand: to.params.brand,
            urlModel: to.params.urlModel
        });

        // Ensure the client side state and the server side DB record are in sync
        // If we don't have a configuration ID, then this will create a record on the server and set the configuration ID on the state to the newly created record's ID
        // If we have a configuration ID, but our state is empty, then this should load the configuration data from the server and update the client side state to match it
        // Else if we have a configuration ID, and it matches the one in our state, POST to the server to update the DB record to match the current state
        const syncDatabaseResponse = await store.dispatch('syncDatabase', to.query);

        // If the route requirements are met, redirect to the next page without changing anything (except for maybe adding the configuration ID above)
        if (!syncDatabaseResponse.redirect && routeRequirementsMet(to.name)) {
            if (!to.query.id) {
                next({
                    name: to.name,
                    query: {...to.query, id: syncDatabaseResponse.id},
                    params: to.params,
                });
                return;
            }

            // potentially where I want to clear my state when going back//
            //
            //

            next();
            return;
        }

        // If we get this far then the current state doesn't support the route we're trying to navigate to (the current 'to' variable)
        // Get the best route the state currently would allow the client to view
        const bestRouteToRedirectTo = getBestMatchingRouteBasedOnCurrentState();

        if (syncDatabaseResponse.redirect) {
            if (!to.query.id) {
                next({
                    name: bestRouteToRedirectTo,
                    query: {...to.query, id: syncDatabaseResponse.id},
                    params: to.params,
                });
            } else {
                next({
                    name: bestRouteToRedirectTo,
                    query: to.query,
                    params: to.params,
                });
            }
            return;
        }

        // Notify the customer that they need to be on a different route and redirect them
        Swal.fire({
            title: 'Something went wrong',
            text: 'You do not have the necessary data to be at this stage',
            icon: 'error',
            buttonStyling: false,
            customClass: {
                confirmButton: 'btn btn-primary'
            }
        }).then(() => {
            if (!to.query.id) {
                next({
                    name: bestRouteToRedirectTo,
                    query: {...to.query, id: syncDatabaseResponse.id},
                    params: to.params,
                });
                return;
            }

            next({
                name: bestRouteToRedirectTo,
                query: to.query,
                params: to.params,
            });
        });
    } catch (error) {
        // This is a fallback if anything went wrong with anything above
        Swal.fire({
            title: 'Something went wrong',
            text: 'You do not have the necessary data to be at this stage',
            icon: 'error',
            buttonStyling: false,
            customClass: {
                confirmButton: 'btn btn-primary'
            }
        }).then(() => {
            next({
                name: 'select-model',
                params: {brand: to.params.brand},
                query: to.query,
            });
        });
    }
});

export default router;